import { render, staticRenderFns } from "./ProductCompare.vue?vue&type=template&id=66cb9e58&scoped=true&"
import script from "./ProductCompare.vue?vue&type=script&lang=js&"
export * from "./ProductCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cb9e58",
  null
  
)

export default component.exports